import React from 'react';
import PropTypes from 'prop-types';
import KpiSummary from '../../../commons/KpiSummary';

const ContentCourseErrorRateSummary = (props) => (
  <KpiSummary
    isLoading={props.isLoading}
    title="Error report"
    previousValue={props.previousValue}
    currentValue={props.currentValue}
    formatter={props.formatter}
  />
);

ContentCourseErrorRateSummary.propTypes = {
  isLoading: PropTypes.bool,
  currentValue: PropTypes.string.isRequired,
  previousValue: PropTypes.string.isRequired,
  formatter: PropTypes.func.isRequired,
};

ContentCourseErrorRateSummary.defaultProps = {
  isLoading: false,
};

export default ContentCourseErrorRateSummary;
